import { Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

type StatusVariant = "success" | "error" | "warning" | "info";

interface StatusLabelProps {
  message: string;
  variant?: StatusVariant;
  icon?: ReactElement;
}

export const StatusLabel = ({ message, variant = "success", icon }: StatusLabelProps) => {
  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      sx={(theme) => ({
        px: 1,
        py: 0.75,
        color: theme.palette[variant].main,
      })}
    >
      <Typography
        variant="body2"
        fontWeight="bold"
        sx={{
          textTransform: "uppercase",
          fontWeight: 500,
        }}
      >
        {message}
      </Typography>
      {icon}
    </Stack>
  );
};
